import { openPopup } from '../helper/utils'
import { BaseProvider } from './base-provider'
import sharedConfig from '@web-publish-id/shared/config'

/**
 * Discord登录提供者
 */
export class DiscordProvider extends BaseProvider {
  protected readonly clientId = sharedConfig.discordClientId

  constructor() {
    super()
  }

  public async oAuth() {
    const baseUrl = 'https://discord.com/oauth2/authorize'
    const state = {
      client_id: this.clientId,
      channel: 'discord',
    }

    const selfUrl = `${sharedConfig.origin}/web/code-callback/discord`
    const redirectUri = sharedConfig.serverRedirectUri + `?redirect=${selfUrl}`

    const params = new URLSearchParams({
      client_id: this.clientId,
      redirect_uri: redirectUri,
      response_type: 'code',
      scope: 'identify email',
      // state: JSON.stringify(state),
    })

    const url = `${baseUrl}?${params.toString()}`
    const result = await openPopup(url)

    console.log('result :>> ', result)

    return { access_token: result.code, extend: redirectUri }
  }
}
